import { AddressType, AddressFieldName } from '@/api/types';

import { PlaceOfResidenceDataFieldName } from '../../../../../../../components/Forms/Steps/PlaceOfResidence';
import { AddressCheckAlertAddressType } from '../../../../../../../components/Modals/AddressCheckAlert';

export enum DeclaredAddressNewFieldName {
  declaredAddressNew = 'declaredAddressNew',
  declaredAddressNewDocuments = 'declaredAddressNewDocuments',
  issuedResidence = 'issuedResidence',
  expiredResidence = 'expiredResidence',
}

export type AddressMapping = Partial<Record<PlaceOfResidenceDataFieldName, AddressFieldName>>;

export const ADRESSES_MAPPING: Record<AddressCheckAlertAddressType, AddressMapping> = {
  [AddressType.REGISTRATION]: {
    [PlaceOfResidenceDataFieldName.registeredCountry]: AddressFieldName.country,
    [PlaceOfResidenceDataFieldName.registeredRegion]: AddressFieldName.region,
    [PlaceOfResidenceDataFieldName.registeredDistrict]: AddressFieldName.district,
    [PlaceOfResidenceDataFieldName.registeredStreet]: AddressFieldName.street,
    [PlaceOfResidenceDataFieldName.registeredHouse]: AddressFieldName.house,
    [PlaceOfResidenceDataFieldName.registeredCorps]: AddressFieldName.building,
    [PlaceOfResidenceDataFieldName.registeredFlat]: AddressFieldName.apartment,
  },
  [AddressType.LIVING]: {
    [PlaceOfResidenceDataFieldName.declaredCountry]: AddressFieldName.country,
    [PlaceOfResidenceDataFieldName.declaredRegion]: AddressFieldName.region,
    [PlaceOfResidenceDataFieldName.declaredDistrict]: AddressFieldName.district,
    [PlaceOfResidenceDataFieldName.declaredStreet]: AddressFieldName.street,
    [PlaceOfResidenceDataFieldName.declaredHouse]: AddressFieldName.house,
    [PlaceOfResidenceDataFieldName.declaredCorps]: AddressFieldName.building,
    [PlaceOfResidenceDataFieldName.declaredFlat]: AddressFieldName.apartment,
  },
};

export interface AddressCheckStatus {
  isError: boolean;
  addressType: Nullable<AddressCheckAlertAddressType>;
}
